import React, { useEffect } from 'react';
import { Polyline } from 'react-leaflet';
import L from 'leaflet';
import 'leaflet-polylinedecorator';

const PolylineWithArrow = ({ locations, polylineColor = '#0bb7af', mapRef }) => {
  const normalizedLocations = (locations || [])
    .map((point) => {
      if (Array.isArray(point) && point.length >= 2) {
        const lat = Number(point[0]);
        const lng = Number(point[1]);
        if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
        return [lat, lng];
      }

      const lat = Number(point?.lat ?? point?.latitude);
      const lng = Number(point?.lng ?? point?.longitude);
      if (!Number.isFinite(lat) || !Number.isFinite(lng)) return null;
      return [lat, lng];
    })
    .filter(Boolean);

  useEffect(() => {
    const map = mapRef?.current;
    if (!map || normalizedLocations.length < 2) return;

    let decorator = null;

    try {
      decorator = L.polylineDecorator(normalizedLocations, {
        patterns: [
          {
            offset: '5%',
            repeat: '20%',
            symbol: L.Symbol.arrowHead({
              pixelSize: 10,
              headAngle: 30,
              polygon: false,
              pathOptions: {
                color: '#1c4b75',
                weight: 1,
                fill: false,
              },
            }),
          },
        ],
      }).addTo(map);
    } catch {
      decorator = null;
    }

    return () => {
      if (decorator && map?.hasLayer?.(decorator)) {
        map.removeLayer(decorator);
      }
    };
  }, [normalizedLocations, mapRef, polylineColor]);

  return (
    <Polyline
      positions={normalizedLocations}
      pathOptions={{ color: polylineColor, weight: 6, opacity: 0.8 }}
    />
  );
};

export default PolylineWithArrow;